var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSadC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.52 85.04C66.0031 85.04 85.04 66.0031 85.04 42.52C85.04 19.0369 66.0031 0 42.52 0C19.0368 0 0 19.0369 0 42.52C0 66.0031 19.0368 85.04 42.52 85.04Z",
    fill: "#FCC332"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.08 51.56H43.1C42.41 51.56 41.85 52.12 41.85 52.81C41.85 53.5 42.41 54.06 43.1 54.06H43.84C43.84 56.41 45.74 58.31 48.09 58.31C50.44 58.31 52.34 56.41 52.34 54.06H53.08C53.77 54.06 54.33 53.5 54.33 52.81C54.33 52.12 53.77 51.56 53.08 51.56Z",
    fill: "#331100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9299 51.56H12.95C12.26 51.56 11.7 52.12 11.7 52.81C11.7 53.5 12.26 54.06 12.95 54.06H13.6899C13.6899 56.41 15.5899 58.31 17.9399 58.31C20.2899 58.31 22.19 56.41 22.19 54.06H22.9299C23.6199 54.06 24.1799 53.5 24.1799 52.81C24.1799 52.12 23.6199 51.56 22.9299 51.56Z",
    fill: "#331100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.38 64.96C39.05 64.96 38.72 64.85 38.44 64.63C38.34 64.55 36.33 63.03 32.56 63.03C29.1 63.03 26.83 64.57 26.81 64.59C26.13 65.06 25.2 64.9 24.72 64.22C24.25 63.54 24.4 62.62 25.08 62.14C25.2 62.05 28.1 60.03 32.56 60.03C37.48 60.03 40.21 62.2 40.33 62.29C40.97 62.81 41.07 63.76 40.55 64.4C40.25 64.76 39.82 64.95 39.38 64.95V64.96Z",
    fill: "#331100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSadC);
export default __webpack_public_path__ + "static/media/ic_sad_c.e01caf99e6e1107a6b8c73d1d84a5eb7.svg";
export { ForwardRef as ReactComponent };